<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <!-- 主表单区域 -->
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8" >
            <a-form-item :label="$t('label.applicationType')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled  type="list" v-decorator="['applyType',{'initialValue':'20'}]" :trigger-change="true" dictCode="sqlx" placeholder="请选择申请类型"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.farms')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list"
                                 v-decorator="['farmCode',validatorRules.farmCode]"
                                 :trigger-change="true"
                                 @change="handleFarmerChange"
                                 dictCode="sys_depart,depart_name,org_code,org_category='5' and del_flag='0'"
                                 :placeholder="$t('label.pleaseSelectFarms')"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.feedingLot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['breedBatchCode',validatorRules.breedBatchCode]" @change="handleBreedBatchCodeChange" :trigger-change="true" :dictCode="dictBreedBatchCode" :placeholder="$t('label.pleaseSelectTheFeedingLot')"/>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.grower')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list"  v-decorator="['farmerCode',validatorRules.farmerCode]" :trigger-change="true" :dictCode="dictFarmerCode" :placeholder="$t('label.pleaseSelectGrower')" />
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.company')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled v-decorator="['companyCode']" placeholder="请输入公司"></a-input>
            </a-form-item>
          </a-col>
<!--          <a-col :span="8" >-->
<!--            <a-form-item label="申请金额" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <a-input-number v-model="applyAmount"  ref="applyAmount"  @change="handleCalculateAmount" placeholder="请输入申请金额" style="width: 100%"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :span="8" >-->
<!--            <a-form-item label="金额合计" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <a-input-number disabled v-model="totalAmount"  ref="totalAmount" placeholder="请输入金额合计" style="width: 100%"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :span="8" >
            <a-form-item :label="$t('label.applicant')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                :triggerChange="true"
                dictCode="sys_user,realname,username,del_flag = '0'"
                v-decorator="['applicant', {'initialValue': initApplyUser, rules: validatorRules.applicant.rules}]"
              />
              <!--<a-input v-decorator="['applicant']" placeholder="请输入申请人"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item :label="$t('label.documentDate')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('label.pleaseSelectDocumentDate')" v-decorator="['applyTime',{'initialValue': initAccountPeriod, rules: validatorRules.applyTime.rules}]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
<!--          <a-col :span="8" >-->
<!--            <a-form-item label="申请原因" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <a-input v-decorator="['applyReason',validatorRules.applyReason]" placeholder="请输入申请原因"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
         <!-- <a-col :span="8" >
            <a-form-item label="是否有效" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['validFlag',{'initialValue': 'Y'}]" :trigger-change="true" dictCode="sfyx" placeholder="请选择是否有效"/>
            </a-form-item>
          </a-col>-->
          <a-col :span="8" >
            <a-form-item v-has="'lastApprover'"  label="最后审批人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['lastApprover']" placeholder="请输入最后审批人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8" >
            <a-form-item v-has="'lastApproveTime'"  label="最后审批时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择最后审批时间" v-decorator="['lastApproveTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>

        </a-row>
      </a-form>
    </j-form-container>
      <!-- 子表单区域 -->
    <a-tabs v-model="activeKey" @change="handleChangeTabs">
      <a-tab-pane tab="申请项" :key="refKeys[0]" :forceRender="true">
        <j-editable-table
          :ref="refKeys[0]"
          :loading="efsStlSettleApplyDetailTable.loading"
          :columns="efsStlSettleApplyDetailTable.columns"
          :dataSource="efsStlSettleApplyDetailTable.dataSource"
          :maxHeight="300"
          :disabled="formDisabled"
          :rowNumber="true"
          :rowSelection="true"
          @valueChange="handleValueChange"/>
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { FormTypes,getRefPromise } from '@/utils/JEditableTableUtil'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import moment from "moment"
  import { getCurrentUser } from '@api/api'

  export default {
    name: 'EfsStlSettleApplyForm',
    mixins: [JEditableTableMixin],
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
    },
    data() {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        breedBatchDicCode:'',
          validatorRules: {
              farmCode: {
                  rules: [
                      { required: true, message: '请选择养殖场!'},
                  ]
              },
              breedBatchCode: {
                  rules: [
                      { required: true, message: this.$t('label.pleaseSelectTheFeedingLot')},
                  ]
              },
              farmerCode: {
                  rules: [
                      { required: true, message: this.$t('label.pleaseSelectGrower')},
                  ]
              },
              applicant: {
                  rules: [
                      { required: true, message: '请选择申请人!'},
                  ]
              },
              applyTime: {
                  rules: [
                      { required: true, message: this.$t('label.pleaseSelectDocumentDate')},
                  ]
              },
              // applyReason: {
              //     rules: [
              //         { required: true, message: '请输入申请原因!'},
              //     ]
              // },
          },
        refKeys: ['efsStlSettleApplyDetail', ],
        tableKeys:['efsStlSettleApplyDetail', ],
        activeKey: 'efsStlSettleApplyDetail',
        // efs_stl_settle_apply_detail
        efsStlSettleApplyDetailTable: {
          loading: false,
          dataSource: [],
          columns: [
            {
              title: '申请类别',
              key: 'categoryCode',
              type: FormTypes.select,
              dictCode:"jcxfl",
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            {
              title: '申请项目',
              key: 'archCode',
              type: FormTypes.select,
              dictCode:"efs_md_archives,name,code,arch_type='10' and valid_flag='Y'",
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
            // {
            //   title: '计价方式',
            //   key: 'pricingMethod',
            //   type: FormTypes.input,
            //   width:"200px",
            //   placeholder: '请输入${title}',
            //   defaultValue: '',
            // },
            {
              title: '申请单价',
              key: 'unitPrice',
              type: FormTypes.inputNumber,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: 0,
            },
            {
              title: this.$t('tableHeader.remarks'),
              key: 'notes',
              type: FormTypes.input,
              width:"200px",
              placeholder: this.$t('tip.pleaseInput') +'${title}',
              defaultValue: '',
            },
          ]
        },
        url: {
          add: "/settlePolicyApply/efsStlSettleApply/add",
          edit: "/settlePolicyApply/efsStlSettleApply/edit",
          queryById: "/settlePolicyApply/efsStlSettleApply/queryById",
          efsStlSettleApplyDetail: {
            list: '/settlePolicyApply/efsStlSettleApply/queryEfsStlSettleApplyDetailByMainId'
          },
          queryByConCode: '/batchManage/efsMdBreedBatch/queryByBatchCodeNews'
        },
          totalAmount:"",
          applyAmount:"",
          dictFarmerCode:"",
          dictBreedBatchCode:"",
          initApplyUser: null,
          initAccountPeriod: moment(new Date()).format('YYYY-MM-DD')
      }
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：false流程表单 true普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
        getCurrentUser().then((res) => {
            if (res.success) {
                this.initApplyUser = res.result.username;
            }
        });
    },
    methods: {
      addBefore(){
        this.form.resetFields()
        this.efsStlSettleApplyDetailTable.dataSource=[];
        this.totalAmount="";
      },
      getAllTable() {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter() {
        this.totalAmount="";
        this.applyAmount="";
        let fieldval = pick(this.model,'applyType','farmCode','farmerCode','companyCode','applyAmount','totalAmount','applicant','applyTime','lastApprover','lastApproveTime','applyReason','validFlag','breedBatchCode')
        this.totalAmount = this.model.totalAmount;
        this.applyAmount = this.model.applyAmount;
        if(!this.model.id){
            this.applyAmount=0;
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
          if(this.model.id){
              this.dictFarmerCode = "efs_md_farmer,name,code, code = (SELECT t2.farmer_code FROM sys_depart AS t1 LEFT JOIN sys_depart_extend AS t2 ON t1.id = t2.id WHERE t1.org_code ='" + this.model.farmCode + "') and del_flag = 'N'";
              this.dictBreedBatchCode="efs_md_breed_batch,name,code, farm_code = '" + this.model.farmCode + "' and del_flag = 'N'";
          }else {
              this.model.farmerCode = '';
              this.model.breedBatchCode = '';
          }
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(this.url.efsStlSettleApplyDetail.list, params, this.efsStlSettleApplyDetailTable)
        }
      },
      /** 整理成formData */
      classifyIntoFormData(allValues) {
        let main = Object.assign(this.model, allValues.formValue)
          main.totalAmount = this.totalAmount;
          main.applyAmount = this.applyAmount;
        return {
          ...main, // 展开
          efsStlSettleApplyDetailList: allValues.tablesValue[0].values,
        }
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          })
        }
      },
      validateError(msg){
        this.$message.error(msg)
      },
     popupCallback(row){
       this.form.setFieldsValue(pick(row,'applyType','farmCode','breedBatchCode','farmerCode','companyCode','applyAmount','totalAmount','applicant','applyTime','lastApprover','lastApproveTime','applyReason','validFlag'))
     },

      /*changeFarmCode(event) {
        this.breedBatchDicCode =
          "efs_md_breed_batch,name,code,farm_code like '" + event + "*' and del_flag = '0'"
        if (!this.model.operCode) {
          this.model.batchDicCode = ''
          this.form.setFieldsValue(
            pick(
              this.model,
              'batchDicCode',
            )
          )
        }
      },*/
        handleCalculateAmount(value) {
            this.totalAmount="";
            let main =this.$refs.efsStlSettleApplyDetail.getValuesSync().values;
            main.map((item, index) => {
                this.totalAmount = Number(this.totalAmount)+Number(item.unitPrice);
            });
            this.totalAmount=this.totalAmount+Number(value);
        },
        handleValueChange(event) {
            if(event.column.key === 'unitPrice'){
                this.totalAmount="";
                let main =this.$refs.efsStlSettleApplyDetail.getValuesSync().values;
                main.map((item, index) => {
                    this.totalAmount = Number(this.totalAmount)+Number(item.unitPrice);
                });
                this.totalAmount=this.totalAmount+this.applyAmount;
            }


        },
        handleFarmerChange(value) {
            this.dictFarmerCode = "efs_md_farmer,name,code, code = (SELECT t2.farmer_code FROM sys_depart AS t1 LEFT JOIN sys_depart_extend AS t2 ON t1.id = t2.id WHERE t1.org_code ='" + value + "') and del_flag = 'N'";
            this.dictBreedBatchCode="efs_md_breed_batch,name,code, farm_code = '" + value + "' and del_flag = 'N'";
            this.model.farmerCode = ''
            this.model.breedBatchCode = ''
            this.$nextTick(() => {
                this.form.setFieldsValue(pick(this.model, 'farmerCode','breedBatchCode'))
            })
        },
        handleBreedBatchCodeChange(value) {
            getAction(this.url.queryByConCode, { code: value }).then(res => {
                if (res.success) {
                    this.form.setFieldsValue({
                        companyCode: res.result.departName
                    })
                } else {
                    this.$message.warning(res.message)
                }
            })
        },
    }
  }
</script>

<style scoped>
</style>